import { createAction } from '@reduxjs/toolkit';

import { SET_PROGRAM, type Program } from './types';

export const setProgram = createAction<Program | null, typeof SET_PROGRAM>(SET_PROGRAM);
